import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {User} from '@app/shared';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  loggedUser$: BehaviorSubject<User | undefined> = new BehaviorSubject<User | undefined>(undefined);

  get loggedUser(): Observable<User | undefined> {
    return this.loggedUser$ as Observable<User | undefined>;
  }

  set loggedUser(value: User | undefined) {
    // Se definen los permisos segun el rol
    if (value) {
      value.viewMaestros = value.roleId === 7 || value.roleId === 1;
      value.viewOnlyDriversEquipmentsMaestros = value.roleId === 4;
      value.viewAdministracion = value.roleId === 7 || value.roleId === 1 || value.roleId === 3;
      value.viewMoneyData = value.roleId !== 4 && value.roleId !== 8;
      value.viewUnassignedProjectsAndServices = value.roleId !== 4;
      value.editProject = value.roleId === 5 || value.roleId === 7 || value.roleId === 1;
      value.createContainers = value.roleId === 5 || value.roleId === 7 || value.roleId === 1 || value.roleId === 2;
      value.editService = value.roleId === 2 || value.roleId === 7 || value.roleId === 1;
      // Editar el flujo de un Service que ya tiene SOs no se decide aqui: lo responde el
      // servidor por flujo (FlowEventService.getFlowEditPermission, SOU-539).
      value.generateOrders = value.roleId === 2 || value.roleId === 7 || value.roleId === 1 || value.roleId === 3;
      value.validateOrders = value.roleId === 7 || value.roleId === 1 || value.roleId === 3;
      // SOU-481: emitir, revisar, aprobar y enviar dependen del rol en el PROYECTO, no del
      // roleId; se comprueban en el drawer del EP/OC y en el backend.
      value.approveOrders = value.roleId === 5 || value.roleId === 2;
      value.uploadDocumentsUnlimited = value.roleId !== 4 && value.roleId !== 6 && value.roleId !== 8;
      // Proveedor (4) y Admin Proveedor (8) validan documentos desde el ticket de soporte 4848842e.
      // Solo el Visor (6) queda sin permiso.
      value.validateDocuments = value.roleId !== 6;
      value.uploadDocumentsLimited = value.roleId === 4 || value.roleId === 8;
      value.editSOLimited = value.roleId === 4;
      value.editSOUnlimited = value.roleId === 2 || value.roleId === 7 || value.roleId === 1;
      value.viewAndEditTransportSectionSO = value.roleId === 4;
      value.editSOAdminProveedor = value.roleId === 8;
      value.canMassiveAssignSO = value.roleId === 4 || value.roleId === 8;
      value.createProject = value.roleId !== 4 && value.roleId !== 6 && value.roleId !== 8;
      value.createService = value.roleId !== 4 && value.roleId !== 6 && value.roleId !== 8;
      value.viewEquipmentMaestro = value.viewMaestros || value.viewOnlyDriversEquipmentsMaestros || value.roleId === 8;
      // Editor proveedor (4) puede editar y eliminar en los maestros de Equipos y Conductores:
      // ya podia crear registros en ambos, pero no corregirlos despues.
      value.manageEquipmentMaestro = value.viewMaestros || value.roleId === 8 || value.roleId === 4;
      value.viewDriverMaestro = value.viewMaestros || value.viewOnlyDriversEquipmentsMaestros || value.roleId === 8;
      value.manageDriverMaestro = value.viewMaestros || value.roleId === 8 || value.roleId === 4;
      value.assignEquipments = value.editSOUnlimited || value.editSOLimited || value.editSOAdminProveedor;
    }
    this.loggedUser$.next(value);
  }
}
